import React, {useEffect, useRef, useState} from "react";
import {Button, Col, Input, Layout, message, Row, Space, Table} from "antd";
import SettingsSidebar from "./SettingsSidebar";
import {PATH} from "../../../config";
import {NavLink} from "react-router-dom";
import Highlighter from "react-highlight-words";
import axiosData from "../../../helpers/axiosData";
import moment from "moment";
import NumberFormat from "react-number-format";

const {Content} = Layout;

const Wallet = () => {

    const AvatarBG = PATH+'avatarBG.png';
    const DefaultAvatar = PATH+'avatar.png';

    const initVal = {
        referral: "",
        code: ""
    };
    
    const [UserData, setUserData] = useState([]);
    const [SummaryData, setSummaryData] = useState({soto:[0,0], meto:[0,0],busd:[0,0]});
    const [TotalUsd, setTotalUsd] = useState(0);
    const [packages, setPackages] = useState({turnover:0});
    const [Last, setLast] = useState({});
    

    const getUserData = () => {

        axiosData
            .get('/api/_web3/user/wallet/statictics')
            .then((res) => {
                if ( res) {
                    let data = res.data.list;
                    console.log('data', res.data)
                    setUserData(data);
                    setSummaryData(res.data.summary)
                    setTotalUsd(res.data.total_usd)
                    setPackages(res.data.package)
                    setLast(res.data.last)
                    // setLevelData(data.summary) 
                }
            })
            .catch((error) => {
                console.log('status error: ', error)
            })
    }

 
    useEffect(() => {
        getUserData()
    }, [])


    const pageSize = 20;


    const dataReferral = (dataList) => {

        let List = [];

        if (dataList && dataList.length) {
            dataList.forEach(li => {
                
                List.push({
                    key: li.id,
                    username: (
                        li.direction=='in' ? 
                            <div className="flex items-center gap-x-3">
                                <img src={PATH+'mint.svg'} width="21px" />
                                <span className="color-mint">Mint</span>
                            </div>
                        :
                            <div className="flex items-center gap-x-3">
                                <img src={PATH+'burn.svg'} width="21px" />
                                <span className="color-burn">Burn</span>
                            </div>
                         ),
                    date: li.date,
                    source : li.source, 
                    type: li.type,
                    rewards: (
                        <div className="flex items-center gap-x-2">
                            <img src={PATH+li.currency_short.toLowerCase()+'_icon.svg'} alt="" style={{height: "20px"}} />
                            <span className="font-light text-base">{li.value} {li.currency_short}</span>
                        </div>
                    ),
                },)
            });
        }

        return List;
    }

    const dataRef = [
        {
            key: '1',
            username: (
                <div className="flex items-center gap-x-3">
                    <img src={PATH+'mint.svg'} width="21px" />
                    <span className="color-mint">Mint</span>
                </div>),
            date: '28 Feb, 2023',
            source: 'In-App Activity',
            type: 'Quiz',
            rewards: (<div className="flex items-center gap-x-2"><img src={PATH+'meto.svg'} alt="" style={{height: "20px"}} /><span className="font-light text-base">3,000.00 METO</span></div>),
        },
        {
            key: '2',
            username: (
                <div className="flex items-center gap-x-3">
                    <img src={PATH+'burn.svg'} width="21px" />
                    <span className="color-burn">Burn</span>
                </div>),
            date: '28 Feb, 2023',
            source: 'In-App Activity',
            type: 'Rank Up',
            rewards: (<div className="flex items-center gap-x-2"><img src={PATH+'bnb.svg'} alt="" style={{height: "20px"}} /><span className="font-light text-base">93.25 BUSD</span></div>),
        },
        {
            key: '3',
            username: (
                <div className="flex items-center gap-x-3">
                    <img src={PATH+'mint.svg'} width="21px" />
                    <span className="color-mint">Mint</span>
                </div>),
            date: '28 Feb, 2023',
            source: 'In-App Activity',
            type: 'Welcome Reward',
            rewards: (<div className="flex items-center gap-x-2"><img src={PATH+'soto.svg'} alt="" style={{height: "20px"}} /><span className="font-light text-base">125,000 SOTO</span></div>),
        },
        {
            key: '4',
            username: (
                <div className="flex items-center gap-x-3">
                    <img src={PATH+'mint.svg'} width="21px" />
                    <span className="color-mint">Mint</span>
                </div>),
            date: '28 Feb, 2023',
            source: 'In-App Activity',
            type: 'Daily Task Reward',
            rewards: (<div className="flex items-center gap-x-2"><img src={PATH+'soto.svg'} alt="" style={{height: "20px"}} /><span className="font-light text-base">125,000 SOTO</span></div>),
        },
        {
            key: '5',
            username: (
                <div className="flex items-center gap-x-3">
                    <img src={PATH+'referral.svg'} alt=""/>
                    <span className="text-cyan-500">Jim Green</span>
                </div>),
            date: '28 Feb, 2023',
            source: 'Referral Program',
            type: 'March 2023',
            rewards: (<div className="flex items-center gap-x-2"><img src={PATH+'soto.svg'} alt="" style={{height: "20px"}} /><span className="font-light text-base">125,000 SOTO</span></div>),
        },
    ];


    const columns = [
        {
            title: '',
            width: 200,
            dataIndex: 'username',
            key: 'username',
            fixed: 'left', 
        },
        {
            title: 'DATE',
            width: 150,
            dataIndex: 'date',
            defaultSortOrder: 'descend',
            sorter: (a, b) => new Date(a.date) - new Date(b.date),
            key: 'date',
        },
        {
            title: 'SOURCE',
            dataIndex: 'source',
            key: 'source',
            width: 150,
        },
        {
            title: 'TYPE',
            dataIndex: 'type',
            key: 'type',
            width: 170,
        },
        {
            title: 'REWARDS',
            dataIndex: 'rewards',
            key: 'rewards',
            width: 180,
        },
    ];




    return <div className="container mx-auto pt-162 min-h-calc-head h-full">
        <Layout className="h-full settings-layout">
            <SettingsSidebar />
            <Content className="pt-8 pl-10 pr-4 settings-content">
                <h3 className="text-xl text-white font-bold mb-12 settings-title">Wallet</h3>

                <h3 className="text-gray-300 text-lg font-light">My Account Balance</h3>
                {/*<p className="font-light mb-0">You have the potential to increase your earnings by inviting a greater number of individuals.</p>*/}
                <Row gutter={24} className="mb-16">
                    <Col xs={24} sm={24} md={12} lg={8} className="mt-10">
                        <div className="relative rounded-xl px-4 py-8 flex justify-center items-center overflow-hidden" style={{minHeight: '165px', background: '#1c1a42'}}>
                            <div className="w-100 h-full bg-indigo-900 absolute rounded-xl z-1" style={{opacity: "50%"}}></div>
                            <img src={PATH+'soto_icon.svg'} alt="" style={{height: "100%", filter: "grayscale(1)", opacity: ".2", scale: "1.4"}} className="absolute" />
                            <span className="absolute top-0 left-0 mt-4 ml-4 z-2" style={{color: '#45EAFF'}}>SOTO</span>
                            <div className="flex gap-x-3 z-2">
                                <img src={PATH+'soto_icon.svg'} alt="" style={{height: "48px"}} />
                                <div className="text-right">
                                    <span className="text-3xl font-light">
                                        <NumberFormat
                                            value={SummaryData.soto[0]}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            renderText={(value) =><>{value}</>}
                                        />
                                    </span>
                                    {Last && Last.soto ? 
                                        <p className="mb-0 text-xs" style={{color: Last.soto.direction=='in'?'#00FF38':'#EF5261'}}>{Last.soto.direction=='in'?'+ ':'- '}
                                            <NumberFormat
                                                value={Last.soto.value}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                renderText={(value) =><>{value}</>}
                                            /> SOTO</p>
                                    :''}
                                </div>
                            </div>
                        </div>
                        {/*<div className="text-right mt-2">*/}
                        {/*    <a href="" target="_blank" className="text-white font-bold text-sm">Get <img src={PATH+'soto.svg'} alt="" style={{height: "16px"}}/> SOTO</a>*/}
                        {/*</div>*/}
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8} className="mt-10">
                        <div className="relative rounded-xl px-4 py-8 flex justify-center items-center overflow-hidden" style={{minHeight: '165px', background: '#1c1a42'}}>
                            <div className="w-100 h-full bg-indigo-900 absolute rounded-xl opacity-50"></div>
                            <img src={PATH+'meto_icon.svg'} alt="" style={{height: "100%", filter: "grayscale(1)", opacity: ".15", scale: "1.4"}} className="absolute" />
                            <span className="absolute top-0 left-0 mt-4 ml-4" style={{color: '#CF4EF7'}}>METO</span>
                            <div className="flex gap-x-3 z-1">
                                <img src={PATH+'meto_icon.svg'} alt="" style={{height: "48px"}} />
                                <div className="text-right">
                                    <span className="text-3xl font-light">
                                        <NumberFormat
                                            value={SummaryData.meto[0]}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            renderText={(value) =><>{value}</>}
                                        />
                                    </span>
                                    {Last && Last.meto ? 
                                        <p className="mb-0 text-xs" style={{color: Last.meto.direction=='in'?'#00FF38':'#EF5261'}}>{Last.meto.direction=='in'?'+ ':'- '}
                                            <NumberFormat
                                                value={Last.meto.value}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                renderText={(value) =><>{value}</>}
                                            /> METO</p>
                                    :''}
                                </div>
                            </div>
                        </div>
                        <div className="text-right mt-2">
                            <a href="https://promote.mexc.com/a/meto" target="_blank" className="text-white font-bold text-sm">Get <img src={PATH+'meto.svg'} alt="" style={{height: "16px"}} /> METO</a>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8} className="mt-10">
                        <div className="relative rounded-xl px-4 py-8 flex justify-center items-center overflow-hidden" style={{minHeight: '165px', background: '#1c1a42'}}>
                            <div className="w-100 h-full bg-indigo-900 absolute rounded-xl opacity-50"></div>
                            <img src={PATH+'bnb.svg'} alt="" style={{height: "100%", filter: "grayscale(1)", opacity: ".15", scale: "1.4"}} className="absolute" />
                            <span className="absolute top-0 left-0 mt-4 ml-4" style={{color: '#EFB80A'}}>BUSD</span>
                            <div className="flex gap-x-3 z-1">
                                <img src={PATH+'bnb.svg'} alt="" style={{height: "48px"}} />
                                <div className="text-right">
                                    <span className="text-3xl font-light">
                                        <NumberFormat
                                            value={SummaryData.busd[0]}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            renderText={(value) =><>{value}</>}
                                        />
                                    </span>
                                    {Last && Last.busd ? 
                                        <p className="mb-0 text-xs" style={{color: Last.busd.direction=='in'?'#00FF38':'#EF5261'}}>{Last.busd.direction=='in'?'+ ':'- '}
                                            <NumberFormat
                                                value={Last.busd.value}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                renderText={(value) =><>{value}</>}
                                            /> BUSD</p>
                                    :''}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>


                <h3 className="text-gray-300 text-lg font-light">Earnings</h3>
                <p className="font-light mb-0">You have the potential to increase your earnings by inviting a greater number of individuals.</p>
                <Table
                    className="referral-table mt-10"
                    columns={columns}
                    pagination={UserData.length > pageSize && {pageSize}}
                    // dataSource={dataRef}
                    dataSource={UserData && UserData.length ? dataReferral(UserData) : dataReferral([]) }
                    scroll={{
                        x: 800,
                    }}
                />
               
 
            </Content>
        </Layout>
    </div>
}

export default Wallet;